var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-date-picker", {
                attrs: {
                  "value-format": "yyyy-MM-dd",
                  type: "daterange",
                  align: "right",
                  "range-separator": "至",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间"
                },
                on: { change: _vm.datechange },
                model: {
                  value: _vm.value2,
                  callback: function($$v) {
                    _vm.value2 = $$v
                  },
                  expression: "value2"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择"
                  },
                  model: {
                    value: _vm.paramsData.designated,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "designated", $$v)
                    },
                    expression: "paramsData.designated"
                  }
                },
                _vm._l(_vm.chooseList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "身份证号" },
                model: {
                  value: _vm.paramsData.id_card,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "id_card", $$v)
                  },
                  expression: "paramsData.id_card"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "姓名" },
                model: {
                  value: _vm.paramsData.name,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "name", $$v)
                  },
                  expression: "paramsData.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticStyle: { display: "flex" }, attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "warning", disabled: !_vm.delIds.length },
                  on: {
                    click: function($event) {
                      return _vm.del(_vm.delIds)
                    }
                  }
                },
                [_vm._v("批量删除")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.exportDataFn } },
                [_vm._v("导出")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          attrs: { data: _vm.tableData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "60px", type: "selection" }
          }),
          _c("el-table-column", {
            attrs: { prop: "student_id", label: "获奖用户ID", align: "center" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "student_name",
              label: "获奖用户姓名",
              align: "center"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "final_score", label: "最终分数", align: "center" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "final_duration",
              label: "最终时长(秒)",
              align: "center"
            }
          }),
          _c("el-table-column", {
            attrs: { label: "奖励层级描述快照", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        style: {
                          backgroundColor: _vm.getRewardColor(
                            scope.row.reward_name
                          ),
                          color: "#fff",
                          border: "none"
                        }
                      },
                      [_vm._v(" " + _vm._s(scope.row.reward_name) + " ")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "180",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.addRewardItem.init(scope.row)
                            }
                          }
                        },
                        [_vm._v(" 修改 ")]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.del([scope.row])
                            }
                          }
                        },
                        [_vm._v(" 删除 ")]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("addRewardItem", {
        ref: "addRewardItem",
        attrs: { eventId: _vm.eventId },
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("addWinner", {
        ref: "addWinner",
        attrs: { eventId: _vm.eventId, eventStatus: _vm.eventStatus }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }